import * as THREE from "three";
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
import LpApp from "./LpApp.js";

export default class Camera
{
    constructor()
    {
        console.log("Created Camera.");
        this.lpApp = new LpApp();

        this.Sizes = this.lpApp.Sizes;
        this.Scene = this.lpApp.Scene;
        this.Canvas = this.lpApp.Canvas;

        this.SetInstance();
        this.SetOrbitControls();

        this.Resize();
    }

    SetInstance()
    {
        this.Instance = new THREE.PerspectiveCamera(
            35,
            this.Sizes.width / this.Sizes.height,
            0.1,
            100
        );

        this.Instance.position.set(6, 4, 8);
        this.Scene.add(this.Instance);
    }

    SetOrbitControls()
    {
        this.controls = new OrbitControls(this.Instance, this.Canvas);
        this.controls.enableDamping = true;
    }

    Resize()
    {
        this.Instance.aspect = this.Sizes.width / this.Sizes.height;
        this.Instance.updateProjectionMatrix();
    }

    Update()
    {
        this.controls.update();
    }
}